
import React from 'react';
import { ListRenderItemInfo, ScrollView, View, StyleSheet, Platform } from 'react-native';
import { Text, Card, Button, Layout, Input, RadioGroup, Radio, CheckBox, Modal } from '@ui-kitten/components';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Q_GET_SURVEY } from '../../data/api/query/q_survey';
import { M_INSERT_USER_ANSWERS, M_INSERT_ANON_USER_ANSWERS } from '../../data/api/mutation/m_surveys';
import { Answer, SurveySection, Question, AnswerGroup, Survey } from '../../data/models/types';
import { ItemTypeHeader, PollTypeHeader } from '../../components/list-items/CardItem';
import { PageLoadingIndicator, LoadingIndicator, ModalLoadingIndicator } from '../../components/LoadingIndicator';
import { AuthContext, CurrentUser } from '../../App';
import { M_INSERT_ANON_USER } from '../../data/api/mutation/m_users';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';
import { handleExpiredJWT } from '../../utils/handleExpiredJWT';
import { GraphQLError } from 'graphql';
import { fetchWithToken, ApiClient } from '../../data/api/client/ApiClient';
import { QuestionCard } from '../../components/list-items/QuestionItem';
import { PoweredByPoall } from '../../components/page-sections/PoweredByPoall';


const HEADER_TOP_MARGIN: number = Platform.OS === 'web' ? 0 : -2;


interface NewUserAnswer {
    question_id: string;
    answer_id: string;
    answer_bool?: boolean
    answer_numeric?: number;
    answer_text?: string;
}

export function TakePollScreen({ navigation, route }): React.ReactElement {
    const { user } = React.useContext(AuthContext);
    const userAuthorized = (user && user.id) ? true : false;
    const params = route?.params;
    console.log('TakeSurveyScreen info', { navigation, route, params });
    const surveyId: string = params?.id;
    const createAnswersMutation: any = userAuthorized ? M_INSERT_USER_ANSWERS : M_INSERT_ANON_USER_ANSWERS;
    const { pageSpacerHorizontal } = useScreenDimensions();

    // setup state
    const [loading, setLoading] = React.useState(true);
    const [surveyCompleted, setSurveyCompleted] = React.useState(false);
    const [modalVisible, setModalVisible] = React.useState(false);
    const surveyRequest = useQuery(Q_GET_SURVEY, { variables: { survey_id: surveyId }, fetchPolicy: 'network-only' });
    const [createUserAnswers] = useMutation(createAnswersMutation);
    const [createAnonUser] = useMutation(M_INSERT_ANON_USER);

    console.log('createAnswersMutation, userAuthorized =' + userAuthorized, createAnswersMutation);


    // return comp
    if (surveyRequest.loading) {
        return (
            <PageLoadingIndicator />
        );
    };
    if (surveyRequest.error) {
        console.log('useQuery', surveyRequest.error);
        return <SurveyStatusCard title={'Poll not found'} navigation={navigation} />;
    };
    if (surveyRequest.data && surveyRequest.data.surveys && surveyRequest.data.surveys.length > 0 && loading) {
        let sectionsAndUserAnswers = [];
        const surveySections: any = surveyRequest.data.surveys[0].survey_sections;
        console.log('Transform the survey to survey + UserAnsers[]', surveySections);

        if (surveySections && surveySections.length > 0) {
            sectionsAndUserAnswers = surveySections;
            setLoading(false);
        }
        else {
            // something happen, we didnt find the survey or survey sections
            setLoading(false);
        }
    }

    console.log('we have data, ', surveyRequest.data)
    const surveySections: any = (surveyRequest && surveyRequest.data && surveyRequest.data.surveys) ? surveyRequest.data.surveys[0] : []
    const surveyType: string = surveySections?.survey_type?.base_type;
    if (surveyType === 'survey' || surveyType === 'poll') {

    }
    console.log('list data (data.surveys[0].survey_sections;) = ', surveySections);


    const _onSubmit = async (userAnswers: NewUserAnswer[]) => {
        setModalVisible(true);
        console.log('_onSubmit() has been called', userAnswers);

        try {
            if (userAnswers) {
                let params: any = undefined;
                const survey: Survey = surveyRequest.data.surveys[0];

                if (!userAuthorized) {
                    let anonUserId: string = undefined;
                    // const createAnonUserResponse: any = await createAnonUser();
                    // anonUserId = createAnonUserResponse.data.insert_anon_users.returning[0].id;
                    const createAnonUserResponse: any = undefined;
                    console.log('createAnonUserResponse', createAnonUserResponse);
                    console.log('anonUserId', anonUserId);
                    params = {
                        user_answers: userAnswers.map((newUserAnswer: NewUserAnswer) => {
                            return {
                                survey_id: survey.id,
                                question_id: newUserAnswer.question_id,
                                answer_id: newUserAnswer.answer_id,
                                answer_bool: newUserAnswer.answer_bool,
                                answer_numeric: newUserAnswer.answer_numeric,
                                answer_text: newUserAnswer.answer_text,
                                user_id: anonUserId
                            }
                        })
                    }
                }
                else {
                    params = {
                        user_answers: userAnswers.map((newUserAnswer: NewUserAnswer) => {
                            return {
                                survey_id: survey.id,
                                question_id: newUserAnswer.question_id,
                                answer_id: newUserAnswer.answer_id,
                                answer_bool: newUserAnswer.answer_bool,
                                answer_numeric: newUserAnswer.answer_numeric,
                                answer_text: newUserAnswer.answer_text
                            }
                        })
                    }
                }



                // save answers
                console.log(`_onSubmit for createUserAnswers() params = `, params, JSON.stringify(params, null, 4));
                const response = await ApiClient.createSurveyUserAnswers(params);
                console.log(`_onSubmit for createUserAnswers() response = `, response);
                if (response && response.data && !response.error) {
                    setSurveyCompleted(true);
                    setModalVisible(false);
                    return;
                }
                else {
                    let alertMessage: string = 'There was an error, please try again';
                    const surveyTitle: string = surveyRequest?.data?.surveys && surveyRequest.data.surveys[0] ? surveyRequest.data.surveys[0].title : undefined;
                    if (response.error && response.error.length) {
                        for (let index = 0; index < response.error.length; index++) {
                            const graphQLError: GraphQLError = response.error[index];
                            if (graphQLError.extensions && graphQLError.extensions.code === 'constraint-violation') {
                                alertMessage = `You\'ve already submitted answers ${surveyTitle ? 'for ' + surveyTitle : undefined}`;
                            }
                        }
                    }
                    alert(alertMessage);
                    setSurveyCompleted(false);
                    setModalVisible(false);
                }
            }
        }
        catch (error) {
            console.log('There was an error, please reload and try again. If you continue to see this error please contact your admin.', { error });
            const graphQLErrors: GraphQLError[] = handleExpiredJWT(error, () => {
                navigation.navigate('LoginOrSignup', { actionType: 'login' });
            });
            if (graphQLErrors[0].extensions.code === 'constraint-violation') {
                alert('You\'ve already submitted answers for this survey. Only one submission per user is allowed.');
            }
            setModalVisible(false);
        }
    }


    if (surveyCompleted) {
        return <SurveyStatusCard title={'We received your submission.\nThank you for participating!'} navigation={navigation} />;
    }

    if (!surveySections) {
        return <SurveyStatusCard title={'Survey not found'} navigation={navigation} />
    }

    return (
        <>
            {(surveyType === 'survey' || surveyType === 'poll') ?
                <UserSurveyAnswerSections
                    survey={surveySections}
                    onSubmit={_onSubmit}
                    spacing={pageSpacerHorizontal}
                    userAuthorized={userAuthorized}
                    user={user}
                />
                : <Text>This survey type doesnt have a view</Text>
            }
            <ModalLoadingIndicator modalVisible={modalVisible} />
        </>
    )
}


interface AnswerAndUserInput extends Answer {
    selected: boolean | number;
}

interface UserSurveyAnswerSectionsProps {
    survey: any;
    onSubmit: (userAnswers: NewUserAnswer[]) => void;
    spacing?: number;
    userAuthorized?: boolean;
    user?: CurrentUser;
}
interface UserSurveyAnswerSectionsState {
    sections: SurveySection[];
}

export class UserSurveyAnswerSections extends React.Component<UserSurveyAnswerSectionsProps, UserSurveyAnswerSectionsState>  {
    constructor(props: Readonly<UserSurveyAnswerSectionsProps>) {
        super(props);
        this.state = {
            sections: props?.survey?.survey_sections,
        }
        console.log('UserSurveyAnswerSections props', props)
    }


    renderItem = (item: SurveySection) => {
        return (
            <View key={item.id}>
                {item.questions.map((question: Question) =>
                    <Layout key={question.id}>
                        {/* <Text category='s1'>{question.question_title}</Text> */}
                        {question.answer_groups.map((ag: AnswerGroup) =>
                            <Layout key={ag.id}>
                                {
                                    question.question_type === 'select' ?
                                        <>
                                            <RadioGroup
                                                selectedIndex={ag.possible_answers.findIndex((answer: AnswerAndUserInput) => answer.selected)}
                                                onChange={(index: number) => this._onSelectChange(item.id, question.id, undefined, index)}
                                            >
                                                {ag.possible_answers.map((answer: AnswerAndUserInput) =>
                                                    <Radio
                                                        key={answer.id}
                                                        text={answer.answer_text}
                                                        style={{ marginVertical: 8 }}
                                                    />
                                                )}
                                            </RadioGroup>
                                        </>
                                        : question.question_type === 'multiselect' ?
                                            <>
                                                {ag.possible_answers.map((answer: AnswerAndUserInput) =>
                                                    <CheckBox
                                                        key={answer.id}
                                                        style={{ marginVertical: 8 }}
                                                        text={answer.answer_text}
                                                        checked={answer.selected as boolean}
                                                        onChange={(checked: boolean) => this._onMultiselectChange(item.id, question.id, answer.id, checked)}
                                                    />
                                                )}
                                            </>
                                            : undefined
                                }
                            </Layout>
                        )}
                    </Layout>
                )}
            </View>
        );
    };

    renderHeader = () => {
        const survey: Survey = this.props.survey;
        const surveyType: string = survey?.survey_type?.base_type;
        return (
            <>
                <PollTypeHeader />
                <Text category='h2'>{survey.title}</Text>
                {/* {survey.description ? <Text category='s1'>{survey.description}</Text> : undefined} */}
                {survey.instructions ? <Text category='p1' appearance='hint'>{survey.instructions}</Text> : undefined}
            </>
        )
    };

    renderFooter = (): React.ReactElement => (
        <>
            <Layout style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button onPress={this._onSubmit} /* style={{ width: 250, flex: 1 }} */>Vote</Button>
                {/* <Text category='p1' appearance='hint'>{`${this.props.userAuthorized ? 'Answering as ' + this.props.user.username : ''}`}</Text> */}
            </Layout>

        </>
    );


    render() {
        let sections: SurveySection[] = this.state.sections;
        // sections = [...sections, ...sections, ...sections, ...sections ];
        const spacing: number = this.props.spacing;
        const level: string = '1';
        return (
            <ScrollView
                contentContainerStyle={{ flex: 1, flexGrow: 1}}
                style={{ flex: 1 }}
            >
                <Layout level={level} style={{flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}>
                    <Card style={[styles.shadow, { maxWidth: 425, minWidth: 300 }]}>
                        {this.renderHeader()}
                        <View style={{ paddingTop: 15, paddingBottom: 20 }}>
                            {sections.map(section => this.renderItem(section))}
                        </View>
                        {this.renderFooter()}
                    </Card>
                </Layout>
                <Layout level={level} style={{ padding: 20 }}>
                    <PoweredByPoall />
                </Layout>
            </ScrollView>

        );
    }


    _onSelectChange = (section_id: string, question_id: string, answer_id: string, answer_value: number) => {
        this.onAnswerChange('select', section_id, question_id, answer_id, answer_value);
    }

    _onMultiselectChange = (section_id: string, question_id: string, answer_id: string, answer_value: boolean) => {
        this.onAnswerChange('multiselect', section_id, question_id, answer_id, answer_value);
    }

    _onTextChange = (section_id: string, question_id: string, answer_id: string, answer_value: string) => {
        this.onAnswerChange('text', section_id, question_id, answer_id, answer_value);
    }

    onAnswerChange = (answer_type: 'select' | 'multiselect' | 'text', section_id: string, question_id: string, answer_id: string, answer_value: number | string | boolean) => {
        console.table({ answer_type, question_id, answer_id, answer_value });
        const newSections: SurveySection[] = this.state.sections.map((section: SurveySection) => {
            if (section.id === section_id) {
                if (section.questions) {
                    const newQuestions: Question[] = section.questions.map((question: Question) => {
                        if (question.id === question_id) {
                            console.log('Found the question we answered', question);
                            if (question.answer_groups && question.answer_groups[0] && question.answer_groups[0].possible_answers) {
                                console.log('Found the answer_groups[0] we need to use', question.answer_groups);
                                const newAnswers: AnswerAndUserInput[] = question.answer_groups[0].possible_answers.map((answer: AnswerAndUserInput, answerIndex: number) => {
                                    console.log('Here is a one of this questions possible answers', answer);
                                    if (answer.id === answer_id || (answer_type === 'select' && answer_value === answerIndex)) {
                                        console.log('====> FOUND! here is the answer that needs to become active or be update', answer);
                                        // text input
                                        if (answer_type === 'text') {
                                            answer.answer_text = answer_value as string;
                                        }
                                        // radio buttons
                                        else if (answer_type === 'multiselect') {
                                            answer.selected = !answer.selected;
                                        }
                                        // checkboxes
                                        else if (answer_type === 'select') {
                                            answer.selected = true;
                                        }
                                        // return updated answer
                                        return { ...answer };
                                    }
                                    else {
                                        if (answer_type === 'select') {
                                            answer.selected = false;
                                        }
                                        return { ...answer };
                                    }
                                });

                                // update question answers
                                question.answer_groups[0].possible_answers = [...newAnswers];
                            }
                            else {
                                throw new Error(`Section ${section_id} was found but couldn't find question with id ${question_id}!`);
                            }
                            // return update question
                            return { ...question };
                        }
                        else {
                            return question;
                        }
                    });
                    section.questions = [...newQuestions];
                    return { ...section };
                }
                else {
                    throw new Error(`Section ${section_id} was found but couldn't find question with id ${question_id}!`);
                }
            }
            else {
                return section;
            }
        });
        console.log('newSections', newSections);
        this.setState({ sections: newSections });
    }

    _onSubmit = () => {
        const userAnswers: NewUserAnswer[] = [];
        this.state.sections.forEach((section: SurveySection) => {
            section.questions.forEach((question: Question) => {
                question.answer_groups[0].possible_answers.forEach((answer: AnswerAndUserInput) => {
                    const userAnswer: NewUserAnswer = {
                        question_id: question.id,
                        answer_id: answer.id,
                        answer_text: undefined,
                        answer_numeric: undefined,
                        answer_bool: undefined
                    }

                    // text input
                    if (question.question_type === 'text') {
                        userAnswer.answer_text = answer.answer_text;
                        userAnswers.push(userAnswer);
                    }
                    // radio buttons
                    else if (question.question_type === 'multiselect' && answer.selected) {
                        userAnswer.answer_id = answer.id;
                        userAnswers.push(userAnswer);
                    }
                    // checkboxes
                    else if (question.question_type === 'select' && answer.selected) {
                        userAnswer.answer_id = answer.id;
                        userAnswers.push(userAnswer);
                    }
                    else {
                        // some other case
                    }
                });
            });
        });

        console.log(`(userAnswers.length !== this.state.sections.length) ? ${userAnswers.length} !== ${this.state.sections[0].questions.length}`);

        if (userAnswers.length < this.state.sections[0].questions.length) {
            alert('Oops!\nLooks like you didn\'t answer all the questions. Please answer all questions before submitting');
            console.log('Oops! Looks like you didn\'t answer all the questions. Please answer all questions before submitting');
        }
        else {
            this.props.onSubmit(userAnswers);
        }
    }
}


const SurveyStatusCard = ({ title, navigation }: { title: string, navigation: any }) => (
    <Layout level='2' style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <Card>
            <Text category='h2' style={{ marginBottom: 20, textAlign: 'center' }}>{title}</Text>
            <Button onPress={() => navigation.navigate('Home')} appearance='ghost'>Go Home</Button>
        </Card>
    </Layout>
);


const styles = StyleSheet.create({
    container: {
        paddingBottom: 16, // match card
        paddingHorizontal: 24, // match card
        borderRadius: 0,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderColor: 'rgb(228, 233, 242)'
    },
    shadow: {
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.23,
        shadowRadius: 2.62,
        
        elevation: 4,
    }
});
